export default {
    // Set vendor
    setPage(context, payload) {
        context.commit('setPage', payload);
    },
    setSelectedLanguage(context, payload) {
        context.commit('setSelectedLanguage', payload);
    },
    canEventInstantBook(context, payload) {
        //context.commit("fetchInstantBookingForSearchPeriod", payload);
        context.commit('fetchCanEventInstantBook', payload);
    },

    // Set vendor
    setVendor(context, payload) {
        context.commit('setVendor', payload);
    },

    // Set rate group
    setRateGroup(context, payload) {
        context.commit('setRateGroup', payload);
    },

    // Set vendor
    setSettings(context, payload) {
        context.commit('setSettings', payload);
    },

    // Set event type
    setEventTypes(context, payload) {
        context.commit('setEventTypes', payload);
    },

    // Set event type
    setEventType(context, payload) {
        context.commit('setEventType', payload);
    },

    // Set packages
    setPackages(context, payload) {
        context.commit('setPackages', payload);
    },

    // Set single package
    setPackage(context, payload) {
        context.commit('setPackage', payload);
    },

    // Set themes
    setThemes(context, payload) {
        context.commit('setThemes', payload);
    },

    // Set classes
    setClasses(context, payload) {
        context.commit('setClasses', payload);
    },

    // Set search
    setSearch(context, payload) {
        context.commit('setSearch', payload);
    },
    unsetSearchCompleted(context) {
        context.commit('unsetSearchCompleted');
    },

    // Set price calendar loading
    setPackagesLoading(context) {
        context.commit('setPackagesLoading');
    },
    unsetPackagesLoading(context) {
        context.commit('unsetPackagesLoading');
    },

    // Set price calendar loading
    setPriceCalendarLoading(context) {
        context.commit('setPriceCalendarLoading');
    },
    unsetPriceCalendarLoading(context) {
        context.commit('unsetPriceCalendarLoading');
    },

    // Set price calendar prices
    resetPriceCalendar(context) {
        context.commit('resetPriceCalendar');
    },
    pushScrolledPast(context, payload) {
        context.commit('pushScrolledPast', payload);
    },
    fetchPriceCalendarPrices(context, payload) {
        context.commit('fetchPriceCalendarPrices', payload);
    },
    fetchInstantBookingDays(context, payload) {
        context.commit('fetchInstantBookingDays', payload);
    },
    fetchInstantBookingForSearchPeriod(context, payload) {
        context.commit('fetchInstantBookingForSearchPeriod', payload);
    },
    fetchAllPriceCalendarPrices(context, payload) {
        payload.forEach((month) => {
            context.commit('fetchPriceCalendarPrices', { y: month.y, m: month.m });
        });
    },

    // Set loading
    unsetLoading(context) {
        context.commit('unsetLoading');
    },

    setSimpleOrder(context) {
        context.commit('setSimpleOrder');
    },

    // Toggle showing prices with/without vat
    toggleVat(context) {
        context.commit('toggleVat');
    },
};
